(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-list"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations-list');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations-list');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function() {
  function initCopyBtns(wrap) {
    wrap.querySelectorAll('.pr-promo-item-btn--copy').forEach(function(btn) {
      if (btn._copyInited) return;
      btn._copyInited = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var code = btn.dataset.copy;
        if (!code) return;
        var orig = btn.textContent;
        function onCopied() {
          btn.textContent = 'Copied!';
          btn.classList.add('is-copied');
          setTimeout(function() { btn.textContent = orig; btn.classList.remove('is-copied'); }, 2000);
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); onCopied(); } catch(err) {}
          document.body.removeChild(ta);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(onCopied).catch(fallback);
        } else {
          fallback();
        }
      });
    });
  }
  function initPromoBar() {
    document.querySelectorAll('.pr-promo-wrap').forEach(function(wrap) {
      if (wrap._promoInited) return;
      wrap._promoInited = true;
      var bar = wrap.querySelector('.pr-promo-bar');
      var detail = wrap.querySelector('.pr-promo-detail');
      if (!bar || !detail) return;
      var overlay = detail.querySelector('.pr-promo-detail__overlay');
      var panel = detail.querySelector('.pr-promo-detail__panel');
      var closeBtn = panel ? panel.querySelector('.pr-promo-detail__close') : null;

      // Mobile only: teleport overlay & panel to body to escape theiaStickySidebar
      // transform which confines position:fixed children to its stacking context.
      // Desktop: keep in DOM so the panel is position:absolute relative to .pr-promo-wrap
      // and scrolls naturally with the page.
      var _mobile = window.innerWidth < 768;
      if (_mobile) {
        if (overlay) document.body.appendChild(overlay);
        if (panel) document.body.appendChild(panel);
      }
      if (panel) initCopyBtns(panel);

      function open() {
        detail.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        if (panel) panel.classList.add('is-open');
        if (_mobile) document.body.style.overflow = 'hidden';
      }
      function close() {
        detail.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        if (panel) panel.classList.remove('is-open');
        if (_mobile) document.body.style.overflow = '';
      }

      if (panel) { panel._promoBar = bar; panel._promoClose = close; }

      bar.addEventListener('click', function(e) {
        e.stopPropagation();
        detail.classList.contains('is-open') ? close() : open();
      });
      if (overlay) overlay.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', function(e) { e.stopPropagation(); close(); });
    });
  }
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.pr-promo-detail__panel.is-open').forEach(function(panel) {
      var bar = panel._promoBar;
      if (panel.contains(e.target)) return;
      if (bar && bar.contains(e.target)) return;
      if (panel._promoClose) panel._promoClose();
    });
  });
  function updateTagsFade() {
    document.querySelectorAll('.pr-promo-tags').forEach(function(tags) {
      if (window.innerWidth >= 768) { tags.classList.remove('is-multirow'); return; }
      var items = tags.querySelectorAll('.pr-promo-tag');
      var multirow = false;
      if (items.length > 1) {
        var firstTop = items[0].getBoundingClientRect().top;
        for (var i = 1; i < items.length; i++) {
          if (items[i].getBoundingClientRect().top > firstTop + 2) { multirow = true; break; }
        }
      }
      tags.classList.toggle('is-multirow', multirow);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initPromoBar(); updateTagsFade(); });
  } else {
    initPromoBar();
    updateTagsFade();
  }
  var _resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(updateTagsFade, 100);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
